import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { MatStepper } from "@angular/material/stepper";
import { CONSTANT } from "src/app/constant";
import { buildPreviewSummaryTitle } from "src/app/shared/utils/form-type-label";

@Component({
	selector: "app-preview-summary",
	templateUrl: "./preview-summary.component.html",
	styleUrl: "./preview-summary.component.scss",
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewSummaryComponent implements OnInit {
	@ViewChild("stepperPreview") stepperPreview!: MatStepper;
	@Input() baseContainerWidth: number = 0;
	@Output() onFinished: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Input() candidates: any[] = [];
	@Input() formType?: string;

	showComment: boolean = false;

	currentCandidateIndex = 0;

	ngOnInit(): void {}

	get isCabinCrew() {
		return (
			this.formType === CONSTANT.FORM_TYPE.cabin_crew || this.formType === CONSTANT.FORM_TYPE.cabin_crew_instructor
		);
	}

	get isTS5OrTS6() {
		return this.formType === CONSTANT.FORM_TYPE.ts_5 || this.formType === CONSTANT.FORM_TYPE.ts_6;
	}

	get isTS1() {
		return this.formType === CONSTANT.FORM_TYPE.ts_1;
	}

	get previewSummaryTitle(): string {
		return buildPreviewSummaryTitle(this.formType);
	}

	get currentCandidate() {
		return this.candidates[this.currentCandidateIndex];
	}

	prevCandidate() {
		if (this.currentCandidateIndex > 0) {
			this.currentCandidateIndex--;
			this.resetStepper();
		}
	}

	nextCandidate() {
		if (this.currentCandidateIndex < this.candidates.length - 1) {
			this.currentCandidateIndex++;
			this.resetStepper();
		}
	}

	resetStepper() {
		if (this.stepperPreview) {
			this.stepperPreview.reset();
		}
	}

	close(done: boolean = false) {
		this.onFinished.emit(done);
	}

	toggleComments() {
		this.showComment = !this.showComment;
	}
}
